import axios from 'axios';
import { PointOfSaleProductEntity } from 'Models/Entities';
import { POS_PRODUCT_API_URL } from 'Constants';

export interface ProductPriceOverridePayload {
	id?: string;
	userDisplayNameId: string;
	userDisplayName?: string;
	price: number;
}

export interface CreatePosProductRequest {
	name: string;
	price: number;
	isDisabled?: boolean;
	priceOverrides?: ProductPriceOverridePayload[];
}

export interface UpdatePosProductRequest extends CreatePosProductRequest {}

export interface PagedResult<T> {
	items: T[];
	total: number;
	page: number;
	pageSize: number;
}

export const fetchPosProducts = async (page = 1, pageSize = 20): Promise<PagedResult<PointOfSaleProductEntity>> => {
	const { data } = await axios.get(POS_PRODUCT_API_URL, {
		params: { page, pageSize },
	});

	return {
		...data,
		items: data.items.map((item: any) => new PointOfSaleProductEntity(item)),
	};
};

export const fetchPosProductById = async (id: string): Promise<PointOfSaleProductEntity> => {
	const response = await axios.get(`${POS_PRODUCT_API_URL}/${id}`);
	return new PointOfSaleProductEntity(response.data);
};

export const createPosProduct = async (productData: CreatePosProductRequest): Promise<PointOfSaleProductEntity> => {
	const response = await axios.post(POS_PRODUCT_API_URL, productData);
	return new PointOfSaleProductEntity(response.data);
};

export const updatePosProduct = async (
	id: string,
	productData: UpdatePosProductRequest,
): Promise<PointOfSaleProductEntity> => {
	const response = await axios.put(`${POS_PRODUCT_API_URL}/${id}`, productData);
	return new PointOfSaleProductEntity(response.data);
};

export const deletePosProduct = async (id: string): Promise<void> => {
	await axios.delete(`${POS_PRODUCT_API_URL}/${id}`);
};
